// @index(!registry): import ${relpath}
import './DashboardNavigationDetailMenu'
import './PlannerNavigationDetailMenu'

// /index

export { getNavigationDetailMenuComponent } from './registry'